import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Grid from "material-ui-next/Grid";
import Typography from "material-ui-next/Typography";
import { CardValue, Loadable, CurrencyValue, InfoTooltip } from "components/support";

export default class Revenues extends Component {
  render() {
    const { value, loading } = this.props;

    return (
      <Row center="xs" className="pb-md full-height">
        <Col xs={12} sm={4} md>
          <Loadable loading={loading} className="full-height">
            <Paper elevation={1} className="full-height">
              <Grid
                container
                alignItems="center"
                justify="center"
                spacing={0}
                className="full-height"
              >
                <Grid item>
                  <Typography type="headline">
                    Faturamento Total
                    <InfoTooltip hint="Inclui faturamento dos opcionais." />
                  </Typography>
                  <CardValue positive={value > 0}>
                    <CurrencyValue value={value} type="money" />
                  </CardValue>
                </Grid>
              </Grid>
            </Paper>
          </Loadable>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/history/sales/revenues/index.jsx